var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodayDish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6126_19298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.375 19.25H1.625C1.00368 19.25 0.5 19.7537 0.5 20.375C0.5 20.9963 1.00368 21.5 1.625 21.5H23.375C23.9963 21.5 24.5 20.9963 24.5 20.375C24.5 19.7537 23.9963 19.25 23.375 19.25Z",
    fill: "url(#paint0_linear_6126_19298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0223 6.06875C15.083 5.84375 15.125 5.61275 15.125 5.375C15.125 3.9275 13.9475 2.75 12.5 2.75C11.0525 2.75 9.875 3.9275 9.875 5.375C9.875 5.6135 9.91625 5.8445 9.97775 6.06875C5.40425 7.20275 2 11.3307 2 16.25C2 16.7525 2.0375 17.255 2.1125 17.75H22.8875C22.9625 17.255 23 16.7525 23 16.25C23 11.3307 19.5958 7.20275 15.0223 6.06875ZM9.647 10.1323C8.20828 10.8024 7.05198 11.9584 6.3815 13.397C6.34081 13.4878 6.28248 13.5695 6.20989 13.6375C6.13731 13.7055 6.05193 13.7584 5.95871 13.7931C5.8655 13.8278 5.76631 13.8436 5.66694 13.8396C5.56756 13.8356 5.46997 13.8118 5.37985 13.7697C5.28973 13.7277 5.20888 13.6681 5.142 13.5945C5.07512 13.5209 5.02356 13.4347 4.9903 13.3409C4.95705 13.2472 4.94277 13.1478 4.9483 13.0485C4.95382 12.9492 4.97905 12.852 5.0225 12.7625C5.84208 11.0048 7.25479 9.59208 9.0125 8.7725C9.19152 8.69678 9.39293 8.69344 9.57436 8.76319C9.75579 8.83294 9.9031 8.97034 9.98529 9.14648C10.0675 9.32262 10.0782 9.52378 10.0151 9.70763C9.95197 9.89148 9.82003 10.0437 9.647 10.1323ZM13.5365 5.8025C13.1952 5.76875 12.8495 5.75 12.5 5.75C12.1505 5.75 11.8048 5.76875 11.4635 5.8025C11.4063 5.66716 11.3762 5.52192 11.375 5.375C11.375 4.75475 11.8798 4.25 12.5 4.25C13.1202 4.25 13.625 4.75475 13.625 5.375C13.625 5.52575 13.5913 5.669 13.5365 5.8025Z",
    fill: "url(#paint1_linear_6126_19298)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6126_19298",
    x1: 12.5,
    y1: 19.25,
    x2: 12.5,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6126_19298",
    x1: 12.5,
    y1: 2.75,
    x2: 12.5,
    y2: 17.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6126_19298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayDish);
export default __webpack_public_path__ + "static/media/todayDish.886c049f7500a9b12aae6aa7ddbbd315.svg";
export { ForwardRef as ReactComponent };